import { render, staticRenderFns } from "./PlayMenu.vue?vue&type=template&id=521fd6e5"
import script from "./PlayMenu.vue?vue&type=script&lang=js"
export * from "./PlayMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports